import styled from 'styled-components';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';

export default function InecoRiskManagerRiskInterventionCard({
  intervention,
  onShowInterventionModal,
}) {
  return (
    <AppCard
      header={
        <>
          <span>Actuación</span>
          <span
            className="pointer float-right"
            title="Editar"
            onClick={onShowInterventionModal}
          >
            <AppRemixIcon icon="edit-box" />
          </span>
        </>
      }
      headerClassName="text-white bg-primary"
      footer={<div className="float-right">{intervention?.date}</div>}
      footerClassName="small px-2 py-1"
    >
      <CardBlock>{intervention?.description}</CardBlock>
    </AppCard>
  );
}

const CardBlock = styled.div`
  min-height: 60px;
`;
